import { useRef, type MutableRefObject } from "react";
import {
  ANALYSIS_CARD_IDS,
  type AnalysisCardId,
} from "src-next/modules/clinical-insights/types/analysisTypes";
import type { LoadPhase } from "src-next/modules/clinical-insights/loadPhase";

/** Callbacks estáveis por card — evita recriar `onLoadPhaseChange` a cada render/useMemo. */
export function useStableAnalysisLoadPhaseCallbacks(
  selectedAnalysisIdRef: MutableRefObject<AnalysisCardId>,
  onWorkspaceLoadPhase: (phase: LoadPhase) => void
): Record<AnalysisCardId, (phase: LoadPhase) => void> {
  const onPhaseRef = useRef(onWorkspaceLoadPhase);
  onPhaseRef.current = onWorkspaceLoadPhase;

  const callbacksRef = useRef<
    Partial<Record<AnalysisCardId, (phase: LoadPhase) => void>>
  >({});

  if (Object.keys(callbacksRef.current).length === 0) {
    for (const id of ANALYSIS_CARD_IDS) {
      callbacksRef.current[id] = (phase: LoadPhase) => {
        if (selectedAnalysisIdRef.current !== id) return;
        onPhaseRef.current(phase);
      };
    }
  }

  return callbacksRef.current as Record<
    AnalysisCardId,
    (phase: LoadPhase) => void
  >;
}
